import React from 'react';
interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  options: {
    value: string;
    label: string;
  }[];
}
export function Select({
  label,
  options,
  className = '',
  ...props
}: SelectProps) {
  return <div className="w-full" data-id="element-134">
      {label && <label className="block text-sm font-medium mb-1.5" data-id="element-135">{label}</label>}
      <select className={`w-full px-3 py-2 border border-input rounded-md bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent ${className}`} {...props} data-id="element-136">
        {options.map(option => <option key={option.value} value={option.value} data-id="element-137">
            {option.label}
          </option>)}
      </select>
    </div>;
}